import { PageType, ThemeType } from 'types/publishedAssets';
import { SurveyType } from 'types/survey';
import { QbSurveyInfo } from 'types/qbSurveyInfo';
import { normalizeLocales } from './normalizeLocale';

interface LanguageSources {
  theme?: Pick<ThemeType, 'languages'>;
  questionnaire?: Pick<QbSurveyInfo, 'available_locales'>;
  survey?: Pick<SurveyType, 'languages'>;
  page?: Pick<PageType, 'available_locales'>;
}

/**
 * The languages the header and footer language menus offer: the page's own languages (a content page's,
 * else a survey's, else a collaborative map's), else the brand's, limited to the brand's languages unless
 * none of the page's is one.
 */
export const determineLanguageMenuLanguages = ({ theme, questionnaire, survey, page }: LanguageSources): string[] => {
  let languages = theme?.languages || [];
  if (questionnaire) {
    languages = normalizeLocales(questionnaire.available_locales);
  }
  if (survey) {
    languages = (survey.languages || []).map((lang) => lang.language_code);
  }
  if (page) {
    languages = page.available_locales || [];
  }
  if (theme?.languages && theme.languages.length > 0) {
    const brandLanguages = languages.filter((lang) => theme.languages.includes(lang));
    if (brandLanguages.length > 0) {
      languages = brandLanguages;
    }
  }
  return languages;
};
